<template>
    <div class="cancel-confirm-container">
        <h1 class="header-1">{{ $t('cancellation.successTitle') }}</h1>
        <p class="description">
            {{ $t('cancellation.successDescription') }}
        </p>

        <PrimaryBtn class="home-btn" @click="goToHome">
            {{ $t('cancellation.home') }}
        </PrimaryBtn>
    </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import PrimaryBtn from "@/components/BaseComponents/PrimaryBtn.vue";

const router = useRouter();

const goToHome = () => {
    router.push("/");
};
</script>

<style scoped>
.cancel-confirm-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: var(--bg-card);
    width: 80%;
    max-width: 600px;
    padding: var(--spacing-4xl);
    border-radius: var(--border-radius-xl);
    box-shadow: var(--shadow-card);
    text-align: center;
}

.header-1 {
    margin-top: 0;
}

.description {
    color: var(--color-text-secondary);
    margin: var(--margin-md) 0 var(--spacing-3xl);
    font-size: var(--font-size-body);
    line-height: var(--line-height-relaxed);
}

.home-btn {
    width: 100%;
    max-width: 250px;
}
</style>
